import { createLogger } from '@app/logger';
import { platformDeploymentConfig } from '@platform/platform-deployment-config';
import { LocaleCode } from '@utils/util-types';
import { isEmpty } from 'lodash';

const log = createLogger('deploymet-config');

export const deploymentConfig = platformDeploymentConfig;

export const redactedConfig = () => {
  const {
    openAiApiKey,
    openRouterApiKey,
    linearApiKey,
    slackApiToken,
    sentryDsn,
    ...rest
  } = deploymentConfig;
  return rest; // todo include partiallyredacted tokens
};

log.info(JSON.stringify(deploymentConfig));

// type ConfigKey = keyof typeof deploymentConfig;
// export const getDeploymentConfig = (key: ConfigKey): string => {
//   // console.log(`getDeploymentConfig(${key}): ${JSON.stringify(deploymentConfig[key])}`);
//   return deploymentConfig[key];
// };

export const volumePreviewL2Url = (dataUrl: string, l2: LocaleCode): string => {
  if (isEmpty(dataUrl)) return null;
  return `${deploymentConfig.spaBaseUrl}/${l2}/masala-preview?url=${dataUrl}`;
};

export const soundbitePreviewL2Url = (
  dataUrl: string,
  l2: LocaleCode
): string => {
  if (isEmpty(dataUrl)) return null;
  return `${deploymentConfig.spaBaseUrl}/${l2}/admin/preview?url=${dataUrl}`;
};

export const gcsConsoleUrl = (path: string) => {
  const bucket = deploymentConfig.gcsFirebaseBucket;
  return `https://console.cloud.google.com/storage/browser/${bucket}/${path}`;
};
